export default __webpack_public_path__ + "static/Row 2.1_Maris Stella High-6ecd2360266502784fdcd14449cf8097.jpg";